import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { StartScreen } from "./StartScreen";
import { PrivacyPolicy } from "./Pages/PrivacyPolicy";
import { NoPage } from "./Pages/NoPage";
import { TermsOfService } from "./Pages/TermsOfService";
import { PaymentPendingPage } from "./Pages/PaymentPendingPage";
import { PaymentErrorPage } from "./Pages/PaymentErrorPage";
import { TermsOfSale } from "./Pages/TermsOfSale";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StartScreen />} />
        <Route path="payment-pending" element={<PaymentPendingPage />} />
        <Route path="payment-error" element={<PaymentErrorPage />} />
        <Route path="terms-of-sale" element={<TermsOfSale />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="terms-of-service" element={<TermsOfService />} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
